<template>
    <figure :class="classes">
        <template v-if="userInfo.avatar">
            <img
                :alt="userInfo | fullname"
                :src="userInfo.avatar"
            />
        </template>

        <template v-else-if="userInfo.name && userInfo.name.length > 0">{{ userInfo | initials }}</template>

        <template v-else>
            <SvgIcon icon="user_default" />
        </template>

        <slot></slot>
    </figure>
</template>

<script>
export default {
    props: {
        userInfo: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'md',
            validator: function(value) {
                return ['xs', 'sm', 'md', 'lg', 'xlg'].indexOf(value) !== -1
            }
        },
        position: {
            type: String,
            default: 'left',
            validator: function(value) {
                return ['left', 'top'].indexOf(value) !== -1
            }
        }
    },
    computed: {
        classes() {
            return {
                'user-avatar': true,
                [`user-avatar--${this.size}`]: true,
                [`user-avatar--${this.position}`]: true,
                [`user-avatar--anonymous`]: !this.userInfo.name || !this.userInfo.name.length > 0
            };
        },
    }

}
</script>
